import React from 'react';

const About = () => (
  // Main section container with padding and background
  <section id="about" className="py-16 bg-pink-50">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      
      {/* Grid Layout for Text and Image */}
      <div className="grid md:grid-cols-2 gap-8 items-center text-left">
        
        {/* Text Column */}
        <div>
          <h2 className="text-3xl font-bold text-purple-800 mb-4">
            About Looks Trend'z
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4 text-justify font-serif italic">
            Welcome to Looks Trend'z salon, where beauty meets relaxation. We offer a wide range of services to pamper you and enhance your natural beauty. Our skilled stylists and therapists are dedicated to providing you with the best experience.
          </p>
          <p className="text-sm text-pink-600 font-semibold">
            — Your journey to flawless beauty starts here.
          </p>
        </div>
        
        {/* Image Column */}
        <div className="rounded-xl shadow-lg overflow-hidden border-4 border-white transform hover:scale-[1.01] transition-transform duration-300">
          {/* Replace the image source with your salon interior or logo */}
          <img 
            src="https://images.pexels.com/photos/7446920/pexels-photo-7446920.jpeg" 
            alt="Interior of a modern, luxurious salon" 
            className="w-full h-auto object-cover max-h-52"
          />
        </div>
        
      </div>
    </div>
  </section>
);

export default About;